import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { theme } from 'antd';
/**
 * studio 暗色模式下算法
 * @param seedToken
 * @param mapToken
 */
export var studioDarkAlgorithm = function studioDarkAlgorithm(seedToken, mapToken) {
  var mergeToken = theme.darkAlgorithm(seedToken, mapToken);
  return _objectSpread(_objectSpread({}, mergeToken), {}, {
    colorBgLayout: '#20252b',
    colorBgContainer: '#282c34',
    colorBgElevated: '#32363e'
  });
};